import React, { useState } from "react";
import { Tag, Popover, Button, Calendar } from "antd";
import { Dayjs } from "dayjs";
import { startOfMonth, endOfMonth, isBefore, isAfter } from "date-fns";
import { useTranslation } from "react-i18next";

type Props = {
  date: Date; // Dinamički datum koji definiše mesec
  customExcludeDates?: string[]; // Opcionalno: niz stringova za isključene datume
  setSelectedDates: (date: any) => void;
  selectedDates: any;
};

const MyMultiDatePicker: React.FC<Props> = ({
  date,
  customExcludeDates = [],
  setSelectedDates,
  selectedDates,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const monthStart = startOfMonth(date);
  const monthEnd = endOfMonth(date);

  const disabledDate = (current: any) => {
    const jsDate = current.toDate?.() || current;
    return isBefore(jsDate, monthStart) || isAfter(jsDate, monthEnd);
  };

  const handleSelect = (day: Dayjs | null) => {
    if (!day || disabledDate(day)) return;

    const exists = selectedDates.some((d: any) => d.isSame(day, "day"));
    const newDates = exists
      ? selectedDates.filter((d: any) => !d.isSame(day, "day"))
      : [...selectedDates, day];

    setSelectedDates(newDates);
  };

  const content = (
    <Calendar
      fullscreen={false}
      style={{ width: 300 }}
      disabledDate={disabledDate}
      dateFullCellRender={(current) => {
        const isSelected = selectedDates.some((d: any) =>
          d.isSame(current, "day")
        );
        const isDisabled = disabledDate(current);

        const style: React.CSSProperties = {
          borderRadius: "50%",
          width: "100%",
          backgroundColor: isSelected ? "#1890ff" : undefined,
          color: isSelected ? "#fff" : undefined,
          opacity: isDisabled ? 0.4 : 1,
          padding: "4px",
          textAlign: "center",
        };

        return <div style={style}>{current.date()}</div>;
      }}
      onSelect={(date) => handleSelect(date)}
    />
  );

  return (
    <div>
      <Popover
        content={content}
        trigger="click"
        open={open}
        onOpenChange={setOpen}
        destroyTooltipOnHide
      >
        <Button>{t("Select dates")}</Button>
      </Popover>

      <div style={{ marginTop: 16 }}>
        {selectedDates?.length ? (
          <strong>{t("Excluded dates")}:</strong>
        ) : undefined}
        {selectedDates.map((date: any) => (
          <Tag key={date.toString()} color="blue">
            {date.format("YYYY-MM-DD")}
          </Tag>
        ))}
      </div>
    </div>
  );
};

export default MyMultiDatePicker;
